import { useEffect, useRef } from 'react';
import { getToken } from '../api';

interface EventHandlers {
  onTradeOpen?: (data: any) => void;
  onTradeClose?: (data: any) => void;
  onBalanceUpdate?: (data: any) => void;
}

export function useEventStream(handlers: EventHandlers) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    const token = getToken();
    if (!token) return;

    let active = true;
    let lastTimestamp = 0;

    const poll = async () => {
      while (active) {
        try {
          const res = await fetch('/api/events/poll', {
            headers: { 'Authorization': `Bearer ${token}` },
          });
          if (res.ok) {
            const event = await res.json();
            if (event && event.timestamp > lastTimestamp) {
              lastTimestamp = event.timestamp;

              if (event.type === 'trade_opened' && handlersRef.current.onTradeOpen) {
                handlersRef.current.onTradeOpen(event.data);
              }
              if (event.type === 'trade_closed' && handlersRef.current.onTradeClose) {
                handlersRef.current.onTradeClose(event.data);
              }
              if (event.type === 'balance_update' && handlersRef.current.onBalanceUpdate) {
                handlersRef.current.onBalanceUpdate(event.data);
              }
            }
          }
        } catch {
          // ignore polling errors
        }
        await new Promise(r => setTimeout(r, 3000));
      }
    };

    poll();

    return () => { active = false; };
  }, []);
}
